import React from 'react';
import { Globe } from 'lucide-react';
import { cn } from '../../lib/utils';
import { getFlagIso2, flagSrc } from '../../lib/countryFlags';

// Small rectangular flag resolved from a country code or name.
// Falls back to a globe icon when the country cannot be resolved
// or the SVG is missing.
const FlagIcon = ({ country, className }) => {
  const iso2 = getFlagIso2(country);
  const [failed, setFailed] = React.useState(false);

  if (!iso2 || failed) {
    return <Globe className={cn('h-5 w-5 text-slate-400', className)} />;
  }
  return (
    <img
      src={flagSrc(iso2)}
      alt={`${country} flag`}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cn('h-5 w-auto rounded-[2px] shadow-sm ring-1 ring-black/10', className)}
    />
  );
};

export { FlagIcon };
